module.exports = __webpack_public_path__ + "static/media/azet-logo.d9986949.png";